import React, { Component } from 'react';
import { ActionCard } from './MediaCard';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem'
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Alert from '@material-ui/lab/Alert';

import DebugPrint from './DebugPrint';

const useStyles = withStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
}));

export class FetchOptions extends Component {
    static displayName = FetchOptions.name;

    constructor(props) {
        super(props);
        this.state = {
            data: [],
            selections: {},
            loading: true,
            id: ''
        };
    }

    componentDidMount() {
        if (this.props.root) {
            this.populateData();
        } else {
            this.setState({
                data: this.props.data.configs,
                selections: this.props.selections,
                loading: this.props.root,
                id: this.props.id
            });
        }
    }

    handleChange(x, y, z)
    {
        let i = 0;
        this.props.onClick(y.props.value)
    }

    renderData(state) {
        let _state = state;
        if (this.props.root) {
        } else {
            state = {
                data: this.props.data.configs,
                selections: this.props.selections,
                loading: this.props.root,
                id: this.props.id
            };
        }

        let classes = useStyles;
        let sel = state.selections[this.props.pcid + '_' + state.id];

        //<InputLabel id="units-label">Units</InputLabel>
        return this.props.type == "5" ? (
            <FormControl variant="outlined" className={classes.formControl} style={{ width: '100%' }}>
                
                <Select
                    labelId="units-label"
                    id="state.id"
                    value={sel}
                    style={{ backgroundColor: 'white' }}
                    onChange={(x,y)=>this.handleChange(x,y)}
                    //label="Units"
                >
                    {state.data.map(dat => {

                        let _selected = sel == dat.id;
                        let _disabled = dat.blInverted ? dat.openclose < this.props.data.blcount : dat.openclose;

                        if (_selected || !_disabled) {
                            // TODO: CODE FOR DYNAMIC JSON RENDERING OF PC
                            //console.log(this.props.data.shortcode + ':' + dat.name);
                        }

                        return (
                            <MenuItem key={dat.id} value={dat.id}>{dat.grouptitle}</MenuItem>
                        )
                    })}
                </Select>
            </FormControl>
        ) : (
            <Grid container spacing={1}>
                {state.data.map((dat,dati) => {

                    let cols = parseInt(this.props.cols || '4');
                    cols = dat.overridecols ? dat.overridecols : cols;
                    // if the property filter is filled in
                    // and the current options tags are included in the filter
                    // allow it to continue
                    let filter = this.props.flt && this.props.flt.filter(e=>e.sel).map(e=>e.v);
                    if (filter.length>0)
                    {
                        let rtnnull = false;
                        if (!dat.tags) {
                            rtnnull = true;
                        } else {
                            let _tags = dat.tags.split(',').map(e => e.trim());
                            filter.forEach(e => {
                                if (!_tags.includes(e))
                                {
                                    rtnnull = true;
                                }
                            });
                        }
                        if (rtnnull)
                        {
                            return null;
                        }
                    }

                    let _sch = this.props.sch;
                    if (_sch) {
                        _sch = _sch.toUpperCase();
                        if (!_sch.includes('*')) { _sch = _sch + '*'; }
                        _sch = this.wildcardToRegExp(_sch)

                        if (!dat.grouptitle.toUpperCase().match(_sch)) {
                            return null;
                        }
                    }

                    //<div>{dat.altdescription}</div>
                    //            {(dat.ord + parseFloat(dat.alwaysprice)) == 0 ? '$0.00' :
                    //                '+ $' + ((dat.ord + parseFloat(dat.alwaysprice))).tocFixed(2)}
                    //<div>{dat.openclose}:{this.props.data.blcount}</div>
                    // + ' ' + dat.openclose + ':' + this.props.data.blcount}

                    let image = dat._image && dat._image.startsWith('http') ? dat._image : 'images/' + dat._image;
                    if (dat._image)
                    {
                        let asdf = 0;
                    }

                    let overTitle = dat.overtitle;// && this.props.cssclass;
                    //if (dat.grouptitle==dat.name)

                    let notstandalone =
                        this.props.pc ||
                        this.props.parts ||
                        this.props.filt ||
                        this.props.binding ||
                        this.props.tags;

                    let dat_grouptitle = dat.grouptitle || '';
                    let titleText = (overTitle ?
                        dat.overtitle : this.formatText(dat_grouptitle.replaceAll('$', 'X'))) +
                        //(notstandalone ? '' : ' (' + dat.name + ')') +
                        '';


                    let links = dat.link01 || dat.link02 || dat.link03;
                    let css = null;// links ? { height: '100%' } : null;

                    // REPLACE WITH INACTIVE
                    if (dat.inactive) { return null; }

                    let _selected = sel == dat.id;
                    let _disabled = dat.blInverted ? dat.openclose < this.props.data.blcount : dat.openclose;

                    // swapping the commented line below this line lets you see grayed out options
                    let cond = //dati > 10 &&
                        !this.props.data.alwaysshowall && _disabled && !_selected;

                    let dat_stocktext = dat.stocktext;
                    if (dat_stocktext?.toLowerCase() == "build to order") dat_stocktext += " (Final Sale)";

                    if (_selected || !_disabled) {
                        // TODO: CODE FOR DYNAMIC JSON RENDERING OF PC
                        //console.log(this.props.data.shortcode + ':' + dat.name);
                    }

                    return (cond ? null :

                            <Grid item xs={12} sm={_selected ? 12 : cols} key={dat.id} style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'stretch',
                            }}>
                                {_disabled && _selected ?
                                    <Alert severity="error">Invalid. Please Adjust.</Alert>:null}
                                <ActionCard
                                    //moreInfo={'test'}
                                    link01={dat.link01} linktext01={dat.linktext01}
                                    link02={dat.link02} linktext02={dat.linktext02}
                                    
                                    class2={!dat.disabledtext ? '' : 'disabledopt'}
                                    theme={this.props.theme}
                                    title={
                                        <span>
                                            {titleText}
                                        </span>
                                            }
                                    selected={_selected} disabled={_disabled}
                                    src={dat._image}
                                    onClick={() => !dat.disabledtext ? this.props.onClick(dat.id) : null}>

                                    {//overTitle ? null :
                                        <React.Fragment>
                                            {dat.disabledtext ? <div style={{ color: 'red', borderTop: '1px solid #CDCDCD', padding: '5px' }}>{dat.disabledtext}</div> : null}
                                            {dat.altdescription ? <div style={{ borderTop: '1px solid #CDCDCD', padding: '5px' }}>{dat.altdescription}</div> : null}
                                            {dat.altdescription2 ? <div style={{ borderTop: '1px solid #CDCDCD', padding: '5px' }}>{dat.altdescription2}</div> : null}
                                            {dat.altdescription3 ? <div style={{ borderTop: '1px solid #CDCDCD', padding: '5px' }}>{dat.altdescription3}</div> : null}
                                            {dat_stocktext ? <div className="stock-text" style={{ borderTop: '1px solid #CDCDCD', padding: '5px' }}>{dat_stocktext}</div> : null}
                                            {
                                                //<div>
                                                //    {!this.props.data.alwaysshowall ? 'T' : 'F'}<hr />
                                                //{_disabled ? 'T' : 'F'}:
                                                //{dat.blInverted ? 'T' : 'F'}:{dat.openclose}:
                                                //{this.props.data.blcount}:{dat.openclose ? 'T' : 'F'}
                                                //<hr />
                                                //    {!_selected ? 'T' : 'F'}<hr />
                                                //</div>
                                                // {dat.bl.length}<hr />
                                                // {dat.bl.length}<hr />
                                                // {dat.bl.map(b => <div>{b.name}</div>)}  
                                                // <div>{dat.blInverted ? '1' : '0'}:{dat.openclose}:{this.props.data.blcount}<br />{dat.id}</div>
                                            }
                                            {dat.altcomponent || dat.altredirect ? <div style={{ borderTop: '1px solid #CDCDCD', padding: '5px', color: 'red' }}>Extended Lead Time</div> : null}
                                        </React.Fragment>
                                    }


                                </ActionCard>

                            </Grid>)
                }
                    )
                }
            </Grid>

        );
    }

    formatText(txt)
    {
        if (txt.includes('_')) {
            return txt.replaceAll(' ', '\u00a0').replaceAll('_', ' ');
        } else {
            return txt;
        }
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderData(this.state,);

        return (
            <div>

                {contents}
            </div>
        );
    }

    async populateData() {
        const response = await fetch('api/ConfigGroupImpl/configs/'+this.props.id);
        const data = await response.json();
        this.setState({
            data,
            //selections: this.props.selections,
            loading: false,
            //id: this.props.id
        });
    }

    /**
     * Creates a RegExp from the given string, converting asterisks to .* expressions,
     * and escaping all other characters.
     */
    wildcardToRegExp(s) {
        return new RegExp('^' + s.split(/\*+/).map(this.regExpEscape).join('.*') + '$');
    }

    /**
     * RegExp-escapes all characters in the given string.
     */
    regExpEscape(s) {
        return s.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
    }
}
